export default "__VITE_ASSET__BdywFW42__"